module.exports = __webpack_public_path__ + "02_short_yellow.5c79813e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/02_short_yellow.png
// module id = /5jk
// module chunks = 0